<template>
  <div class="row">
    <div class="content-tool-title col-sm-3">
      <p style="font-size: 12px; margin-bottom: -10px; padding: 0">
        Хүүхдийн Картын гүйлгээ
      </p>
    </div>
    <div class="col-md-12">
      <div class="content-tool">
        <div class="content-tool-tool">
          <form action="" @submit.prevent="findDate">
            <div class="form-group" style="position: relative">
              <datetime
                type="date"
                v-model="Startdate"
                ref="dateTimePicker1"
                format="yyyy-MM-dd"
                placeholder="эхлэх огноо"
              ></datetime>
              <span
                class="icon-date"
                @click="$refs.dateTimePicker1.isOpen = true"
                ><i class="fas fa-calendar-alt"></i
              ></span>
            </div>
            <div class="form-group" style="position: relative">
              <datetime
                type="date"
                v-model="Enddate"
                ref="dateTimePicker2"
                format="yyyy-MM-dd"
                placeholder="дуусах огноо"
              ></datetime>
              <span
                class="icon-date"
                @click="$refs.dateTimePicker2.isOpen = true"
                ><i class="fas fa-calendar-alt"></i
              ></span>
            </div>
            <input type="submit" class="dashboard-btn" value="Шүүх" />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Datetime } from "vue-datetime";

export default {
  data() {
    return {
      Startdate: "",
      Enddate: "",
      activeNumber: "All",
    };
  },
  methods: {
    //find date filter
    findDate() {
      this.$emit("dateFilter", this.Startdate, this.Enddate);
    },
  },
  components: {
    Datetime,
  },
};
</script>
<style>
.bgImage {
  background-image: url("../../assets/icon/active-icon.png") !important;
}
.bgImage1 {
  background-image: url("../../assets/icon/active-icon-black.png") !important;
}
</style>
